export default "__VITE_ASSET__DsaHC5TD__"